import TextInput from "app/widgets/TextInput/TextInput";
const NumericTextInput = TextInput.extend({
    MIN: -9007199254740992,
    MAX: 9007199254740992,
    options: {
        name: "NumericTextInput",
        currency: false,
        decimals: 2,
        min: -9007199254740992,
        max: 9007199254740992,
        format: null,
        typingFormat: null
    },

    init: function() {
        TextInput.fn.init.apply(this, arguments);
        this.options.format = this._getFormat(this.options.format, this.options.currency, this.options.decimals);
    },

    _getFormat: function(format, isCurrency, decimals) {
        if (format !== null) {
            return format;
        } else if (isCurrency) {
            return "c"
        } else {
            var fill = function(num) {
                if (num <= 0) {
                    return "";
                } else {
                    return "#" + fill(num - 1);
                }
            };
            return "#." + fill(decimals);
        }
    },

    parseValue: function(value) {
        return kendo.parseFloat(value);
    },

    formatValue: function(value) {
        return kendo.toString(value, this.options.format);
    },

    isPresentable: function(value) {
        if (typeof value === "string") {
            var acceptDecimal = this.options.decimals > 0;
            var decimal = kendo.culture().numberFormat["."];
            var decimalsRemaining = this.options.decimals;
            for (var i = 0; i < value.length; i++) {
                var charCode = value.charCodeAt(i);
                if (value[i] === "-") {
                    if (i !== 0 || this.options.min >= 0) {
                        return false;
                    }
                } else if (value[i] === decimal) {
                    if (acceptDecimal) {
                        acceptDecimal = false;
                    } else {
                        return false;
                    }
                } else if (charCode < 48 || charCode > 57) {
                    return false;
                } else {
                    //numbers
                    if (this.options.decimals > 0 && !acceptDecimal) {
                        if (decimalsRemaining === 0) {
                            return false;
                        } else {
                            decimalsRemaining--;
                        }
                    }
                }
            }
            return true;
        } else {
            return false;
        }
    }
});
kendo.ui.plugin(NumericTextInput);
export default NumericTextInput;
